import { render, staticRenderFns } from "./ImagesGallery.vue?vue&type=template&id=c7776538&scoped=true"
import script from "./ImagesGallery.vue?vue&type=script&lang=js"
export * from "./ImagesGallery.vue?vue&type=script&lang=js"
import style0 from "./ImagesGallery.vue?vue&type=style&index=0&id=c7776538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7776538",
  null
  
)

export default component.exports